import type { KeyboardEventHandler } from 'react';
import React, { useEffect } from 'react';
import { AutoComplete, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import debounce from 'lodash.debounce';

interface ISearchFilterSelectOption {
  label: React.ReactNode;
  value: number | string;
}

interface ISearchFilterProps {
  options?: ISearchFilterSelectOption[];
  setSearch: (value: string) => void;
  setSearchString?: (value: string) => void;
  width?: number;
  selectHandler?: (option: string) => void;
}

export const SearchFilter: React.FC<ISearchFilterProps> = (props) => {
  const { options = [], setSearch, setSearchString, width = 350, selectHandler } = props;

  const handleSelect = (value: number) => {
    if (selectHandler) {
      selectHandler(value.toString());
    }
  };

  const handleChange = debounce((search: string) => {
    setSearchString?.(search);
  }, 300);

  const handleSearch: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.target instanceof HTMLInputElement) {
      setSearch(e.target.value);
      e.target.blur();
    }
  };

  const handleClear = () => {
    setSearch('');
  };

  useEffect(() => {
    return () => {
      setSearch('');
    };
  }, []);

  return (
    <AutoComplete
      options={options}
      style={{ width: width || 350 }}
      allowClear
      onSelect={handleSelect}
      onSearch={handleChange}
      onClear={handleClear}>
      <Input prefix={<SearchOutlined />} placeholder='Search' onPressEnter={handleSearch} />
    </AutoComplete>
  );
};
